import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getInvitation, acceptInvitation, checkAuthStatus, loginWithGoogle } from '../services/api';
import '../styles/Invitation.css';

function Invitation() {
  const { token } = useParams();
  const navigate = useNavigate();
  
  const [invitation, setInvitation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [accepting, setAccepting] = useState(false);

  useEffect(() => {
    checkUser();
    loadInvitation();
  }, [token]);

  const checkUser = async () => {
    try {
      const response = await checkAuthStatus();
      if (response.data.authenticated) {
        setUser(response.data.user);
      }
    } catch (error) {
      console.error('שגיאה בבדיקת משתמש:', error);
    }
  };

  const loadInvitation = async () => {
    try {
      const response = await getInvitation(token);
      setInvitation(response.data.invitation);
      setLoading(false);
    } catch (error) {
      console.error('שגיאה בטעינת הזמנה:', error);
      setError(error.response?.data?.message || 'הזמנה לא נמצאה');
      setLoading(false);
    }
  };

  const handleAcceptInvitation = async () => {
    if (!user) {
      loginWithGoogle();
      return;
    }

    setAccepting(true);
    try {
      const response = await acceptInvitation(token);
      alert('הצטרפת בהצלחה לקבוצה!');
      navigate(`/group/${response.data.groupId}`);
    } catch (error) {
      console.error('שגיאה בקבלת הזמנה:', error);
      alert(error.response?.data?.message || 'שגיאה בקבלת הזמנה');
      setAccepting(false);
    }
  };

  if (loading) {
    return (
      <div className="invitation-container">
        <div className="invitation-card">
          <div className="loading-spinner"></div>
          <p>טוען...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="invitation-container">
        <div className="invitation-card error">
          <h2>❌ שגיאה</h2>
          <p>{error}</p>
          <button className="btn-primary" onClick={() => navigate('/')}>
            חזור לדף הבית
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="invitation-container">
      <div className="invitation-card">
        <div className="invitation-icon">📨</div>
        <h1>הוזמנת להצטרף לקבוצה!</h1>
        
        <div className="invitation-details">
          <div className="group-preview" style={{ borderRight: `4px solid ${invitation.group.color}` }}>
            <h2>{invitation.group.name}</h2>
          </div>
          
          <div className="invitation-info">
            <p>
              <strong>{invitation.invitedBy.name}</strong> הזמין אותך להצטרף לקבוצה
            </p>
            <p className="invitation-email">
              הזמנה לאימייל: <strong>{invitation.email}</strong>
            </p>
          </div>
        </div>

        {!user ? (
          <div className="invitation-actions">
            <p className="login-prompt">יש להתחבר עם חשבון Google כדי להצטרף</p>
            <button 
              className="btn-google"
              onClick={loginWithGoogle}
            >
              <img 
                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
                alt="Google" 
              />
              התחבר עם Google
            </button>
          </div>
        ) : user.email.toLowerCase() !== invitation.email.toLowerCase() ? (
          <div className="invitation-actions">
            <p className="error-message">
              ❌ ההזמנה נשלחה ל-{invitation.email}
              <br />
              אתה מחובר כ-{user.email}
            </p>
            <p>יש להתחבר עם החשבון הנכון</p>
            <button className="btn-secondary" onClick={() => navigate('/auth/logout')}>
              התנתק והתחבר מחדש
            </button>
          </div>
        ) : (
          <div className="invitation-actions">
            <button 
              className="btn-primary btn-large"
              onClick={handleAcceptInvitation}
              disabled={accepting}
            >
              {accepting ? 'מצטרף...' : '✓ הצטרף לקבוצה'}
            </button>
            <button 
              className="btn-secondary"
              onClick={() => navigate('/')}
            >
              ביטול
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Invitation;